

/* template para token - validação de email */

export const templateTokenEmail = ({ nome, token }) => `
<!DOCTYPE html>
<html>
    <head>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      
        body {margin: 0; padding: 0; font-family: Tahoma, sans-serif;}

        .token-box {
            border: solid 2px #D95323;
            border-radius: 10px;
            font-size: 2.5rem;
            padding: 0.5rem 1rem;
            color: #2A5056;
            font-weight: bold;
            background-color: #F7F9F8;
        }

      @media only screen and (max-width: 600px) {
        
        .td-stack-logo {
            display: block !important;
            width: 100% !important;    
            margin: 0 !important;
            padding: 15px 0 0 0 !important;
            text-align: center !important;
        }

        .td-stack-text {
            display: block !important;
            width: 100% !important;    
            margin: 0 !important;
            padding: 5px 0 10px 0 !important;
        }

        .td-stack-text-winners {
            text-align: center !important;
            font-size: 20px !important;
        }

        .td-stack-text-agents {
            padding: 10px 0 10px 0 !important;
            font-size: 12px !important;
            text-align: center !important;
        }

        .img-stack {
            display: inline-block !important;
            margin: 0 auto !important;
        }
        
        .token-frame {
            display: block !important;
            width: 40% !important;
        }

      }

    </style>

    </head>

    <body>

    <!-- Header -->
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #DCDCDC; border-radius: 10px;">
        <tr>
            <td class="td-stack-logo" width="50%" style="padding: 20px 0 20px 0; vertical-align: middle;" align="right"><img class="img-stack" src="https://firebasestorage.googleapis.com/v0/b/winners-ai-473119.firebasestorage.app/o/logo.png?alt=media&token=c2e27f70-4560-4a33-8e9c-54bc9db93e28" style="display: block; margin: 0; border: 0;" width="120" /></td>
            <td class="td-stack-text" width="50%" style="padding: 0; vertical-align: middle;">
                <table cellpadding="0" cellspacing="0" border="0" width="100%">
                    <tr><td width="100%" class="td-stack-text-winners" style="font-size: 30px; color: #2A5056; font-weight: bold; text-decoration: none; pointer-events: none;">winners&#8203;-&#8203;ai&#8203;.&#8203;com</td></tr>
                    <tr><td width="100%" class="td-stack-text-agents" style="padding-left: 50px; font-size: 18px; color: #515151; font-weight: bold; letter-spacing: 4px;">AGENTES</td></tr>
                </table>
            </td>
        </tr>
    </table>

    <!-- Conteúdo -->
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="text-align: center;">
        <tr>
            <td style="height: 100px;"></td>
        </tr>
        <tr>
            <td style="font-size: 30px;">Olá, ${nome}.</td>
        </tr>
        <tr>
            <td style="height: 30px;"></td>
        </tr>
        <tr>
          <td style="font-size: 20px; color: #515151">Obrigado pelo seu interesse em nossa plataforma!</td>
        </tr>
        <tr>
            <td style="height: 20px;"></td>
        </tr>
        <tr>
          <td style="font-size: 20px; color: #515151">O envio do token é uma forma segura de garantir a proprietariedade do seu e-mail e a segurança de todos os nossos clientes.</td>
        </tr>
        <tr>
            <td style="height: 30px;"></td>
        </tr>
        <tr>
            <td style="font-size: 20px; color: #515151">Para continuar seu cadastro, digite o token abaixo na plataforma:</td>
        </tr>
        <tr>
            <td style="height: 60px;"></td>
        </tr>

        <!-- Token -->
        <tr>
            <td align="center">
                <table class="token-frame" cellpadding="5" cellspacing="5" border="0">
                    <tr>${token .split("").map((c) => `<td class="token-box">${c}</td>`).join("")}</tr>
                </table>
            </td>
        </tr>

        <tr>
            <td style="height: 70px;"></td>
        </tr>

        <tr>
            <td style="font-size: 15px; color: #555;">Não responda este e-mail, ele é de enviado de forma automática.</td>
        </tr>
        <tr>
            <td style="height: 20px;"></td>
        </tr>
        <tr>
            <td style="font-size: 15px; color: #555;">2025 - Todos os direitos reservados a www.winners-ai.com</td>
        </tr>

    </table>
  </body>
</html>
`;


